var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b28c3492ffe6720d575cc1689eeea595{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H41V41H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b28c3492ffe6720d575cc1689eeea595",
    d: "M16.65,34.979v-10.1h7.7v10.1A1.98,1.98,0,0,0,26.27,37h5.772a1.98,1.98,0,0,0,1.924-2.021V20.834h3.271a1.01,1.01,0,0,0,.635-1.758L21.787,3.86a1.87,1.87,0,0,0-2.578,0L3.125,19.076a1.014,1.014,0,0,0,.635,1.758H7.031V34.979A1.98,1.98,0,0,0,8.955,37h5.772A1.98,1.98,0,0,0,16.65,34.979Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.847da5f8.svg";
export { ForwardRef as ReactComponent };